<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperGuidesAndVideos',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'guidesAndVideosModule',
    };
  },
};
</script>
